import 'uno.css'
export default defineNuxtPlugin(() => {})